define("shared/helpers/format-currency", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.formatCurrency = formatCurrency;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f

  function formatCurrency(_ref
  /*, hash*/
  ) {
    let [value, decimalPlaces = 2] = _ref;
    const priceInCents = value || 0;
    const priceInDollars = priceInCents / 100;
    return `$${priceInDollars.toFixed(decimalPlaces).toLocaleString()}`;
  }

  var _default = _helper.default.helper(formatCurrency);

  _exports.default = _default;
});